import { useTranslation } from "react-i18next";
import { useModal } from "context/ModalContext";
import { getButtonsNoYes } from "context/helpers/helperModalContext";
import { useRef } from "react";
import { useSettings } from "context/SettingsContext";
import { useAuth } from "context/AuthContext";
import { hidesPurchasePrices } from "utils/helpers/access/hasUserAccess";
import ChangePriceSaleForm from "../ChangePriceSale/ChangePriceSaleForm";

const useChangePriceSale = () => {

    const { t } = useTranslation(['Objects', 'Warehouses']);
    const { showDlg } = useModal();
    const { localSettings } = useSettings();
    const { auth } = useAuth();
    const hidePurchase = hidesPurchasePrices(auth?.user);
    const refForm = useRef();
    const paramsDelDlg = {
        buttons : [...getButtonsNoYes(t)],  
        type    : 'confirm',
    } 


    const changePriceSale = ({price, priceSale}, cbFunct) => {
        const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
        const p = {
            ...paramsDelDlg,
            sizeLg: true,
            title : t('changePriceSale.title'),
            text: (
                <ChangePriceSaleForm
                    ref={refForm}
                    variant="modal"
                    price={price}
                    priceSale={priceSale}
                    rate={rate}
                    hidePurchase={hidePurchase}
                    onSubmit={(values) => {
                        showDlg(false);
                        cbFunct(values);
                    }}
                />
            ),
            idFirstFocus:'inputPriceSale'
        }
        p.buttons[1].handleClick = (e) => {  
                e.preventDefault();
                if (refForm.current?.reportValidity()) {
                    refForm.current?.requestSubmit?.();  
                }
        }
        showDlg(p)
    }
 

    return {
        changePriceSale
    }
}

export default useChangePriceSale;
